import ComponentDetailsBanner from "./banner";
export default ComponentDetailsBanner;
